module.exports = __webpack_public_path__ + "images/Assessment.f2e71474.webp";